// reducers/index.js
import { combineReducers } from 'redux';
import snackbar from './reducers/general/snackbar';

import {reducer as datasource_summary} from './reducers/datasources/summary';

import {reducer as error} from './reducers/error/error';
import {reducer as datasource_list} from './reducers/datasources/list';
import {reducer as datasource_schedule} from './reducers/datasources/schedule';
import {reducer as datasource_bulkFetch} from './reducers/datasources/bulkFetch';
import {reducer as datasource_AddUpdateDelete} from './reducers/datasources/addUpdateDelete';
import {reducer as datasource_mock} from './reducers/datasources/mock';
import {reducer as datasource_insights} from './reducers/datasources/insights';
// Data-connect wizard + dataset import flows
import { reducer as datasource_connect_inspect } from './reducers/datasources/connectInspect';
import { reducer as datasource_connect_create } from './reducers/datasources/connectCreate';
import { reducer as datasource_connect_import_file } from './reducers/datasources/connectImportFile';
import { reducer as datasource_connect_webhook } from './reducers/datasources/connectWebhook';
import { reducer as datasource_oauth_start } from './reducers/datasources/oauthStart';
import { reducer as datasource_dataset_inspect } from './reducers/datasources/datasetInspect';
import { reducer as datasource_dataset_import } from './reducers/datasources/datasetImport';
import { reducer as datasource_upload_auto } from './reducers/datasources/uploadAuto';
import { reducer as datasource_connect_inspect_file } from './reducers/datasources/connectInspectFile';
import { reducer as datasource_load_sample } from './reducers/datasources/loadSample';
import { reducer as datasource_create_goal } from './reducers/datasources/createGoal';
import { reducer as datasource_inspect_source } from './reducers/datasources/inspectSource';
import { reducer as datasource_add_jobs } from './reducers/datasources/addJobs';
import { reducer as datasource_edit_job_load } from './reducers/datasources/editJobLoad';
import { reducer as datasource_update_job } from './reducers/datasources/updateJob';
import { reducer as datasource_trigger_job } from './reducers/datasources/triggerJob';
import { reducer as datasource_get_source } from './reducers/datasources/getSource';
import { reducer as datasource_update_source } from './reducers/datasources/updateSource';
import { reducer as ingestion_test_rest_call } from './reducers/ingestion/testRestCall';

import {reducer as signal_list} from './reducers/signals/list';
import {reducer as signal_overview} from './reducers/signals/overview';
import {reducer as signal_correlation} from './reducers/signals/correlation';
import {reducer as signal_causality} from './reducers/signals/causality';
import {reducer as signal_relevance} from './reducers/signals/relevance';
import {reducer as signal_delete} from './reducers/signals/delete';
import {reducer as signal_delete_bulk} from './reducers/signals/deleteBulk';
import {reducer as signal_groups} from './reducers/signals/groups';
import {reducer as signal_group_assign} from './reducers/signals/groupAssign';
import {reducer as signal_ask_data} from './reducers/signals/askData';
import {reducer as signal_latest_analysis} from './reducers/signals/latestAnalysis';
import {reducer as signal_analyze} from './reducers/signals/analyze';

import {reducer as user_getUser} from './reducers/user/getUser';
import { authReducer } from './reducers/auth/auth';

import {reducer as workspace_list} from './reducers/workspaces/list';
import {reducer as workspace_fetch_llm} from './reducers/workspaces/fetchLLM';
import {reducer as workspace_create} from './reducers/workspaces/create';
import {reducer as event_record} from './reducers/events/record';
import {reducer as event_streams} from './reducers/events/streams';
import {reducer as event_stream_events} from './reducers/events/streamEvents';
import {reducer as event_stream_delete} from './reducers/events/deleteStream';
import {reducer as workspace_edit} from './reducers/workspaces/edit';
import {reducer as workspace_delete} from './reducers/workspaces/delete';
import {reducer as workspace_detail} from './reducers/workspaces/detail';

import {reducer as segments_list} from './reducers/segments/list';
import {reducer as segment_create} from './reducers/segments/create';
import {reducer as segment_edit} from './reducers/segments/edit';
import {reducer as segment_delete} from './reducers/segments/delete';
import {reducer as segment_detail} from './reducers/segments/detail';
import segment_fields from './reducers/segments/fields';
import { reducer as segment_preview } from './reducers/segments/preview';

import { reducer as blueprints_list } from './reducers/blueprints/list';
import { reducer as blueprints_public_list } from './reducers/blueprints/publicList';
import { reducer as blueprint_detail } from './reducers/blueprints/detail';
import blueprint_create from './reducers/blueprints/create';
import { reducer as blueprint_deploy_foundation } from './reducers/blueprints/deployFoundation';

import { reducer as models_list } from './reducers/models/list';
import { reducer as modelDetailReducer } from './reducers/models/detail';
import modelCreateReducer from './reducers/models/create';
import modelEditReducer from './reducers/models/edit';
import modelDeleteReducer from './reducers/models/delete';

import { reducer as trainings_list } from './reducers/trainings/list';
import { reducer as training_download } from './reducers/trainings/download';

// Import forecasts reducers
import { reducer as forecasts_list } from './reducers/forecasts/list';
import { reducer as forecast_trigger } from './reducers/forecasts/trigger';
import { reducer as forecasts_predictions } from './reducers/forecasts/predictions';

// Inferences (post-Phase 13.O: replaces the legacy "Forecasts" page).
import { reducer as inferences_list   } from './reducers/inferences/list';
import { reducer as inferences_detail } from './reducers/inferences/detail';

// Import promotion reducers
import { reducer as model_promote } from './reducers/promotion/promote';
import { reducer as promotion_retry } from './reducers/promotion/retry';

// Import deployment reducers
import { reducer as deployments_list } from './reducers/deployments/list';
import { reducer as deployment_delete } from './reducers/deployments/delete';
import { reducer as deployment_detail } from './reducers/deployments/detail';
import { reducer as deployment_usage } from './reducers/deployments/usage';
import { reducer as segment_inference } from './reducers/deployments/inference';

// Import dashboard reducers
import { reducer as dashboard_summary } from './reducers/dashboard/summary';

// Import ingestion reducers
import { reducer as ingestion_sources } from './reducers/ingestion/sources';
import { reducer as ingestion_jobs } from './reducers/ingestion/jobs';
import { reducer as ingestion_executions } from './reducers/ingestion/executions';
import { reducer as ingestion_upload } from './reducers/ingestion/upload';

// Utilities
import utilitiesReducer from './reducers/utilities';

import { reducer as billing_balance       } from './reducers/billing/balance';
import { reducer as billing_transactions  } from './reducers/billing/transactions';
import { reducer as billing_estimate      } from './reducers/billing/estimate';
import { reducer as billing_snapshot      } from './reducers/billing/snapshot';
import { reducer as billing_topup         } from './reducers/billing/topup';
// Stripe-backed subscription + checkout + portal
import { reducer as billing_subscription  } from './reducers/billing/subscription';
import { reducer as billing_checkout      } from './reducers/billing/checkout';
import { reducer as billing_portal        } from './reducers/billing/portal';
// Foundation models: one namespace for every family (predictfm + OSS)
import { reducer as foundation_models_list           } from './reducers/foundation/modelsList';
import { reducer as foundation_model_detail          } from './reducers/foundation/modelDetail';
import { reducer as foundation_adapters_list         } from './reducers/foundation/adaptersList';
// BYOM (bring your own model): upload -> validate -> register wizard + download
import { reducer as foundation_byom_upload            } from './reducers/foundation/byomUpload';
import { reducer as foundation_byom_validate          } from './reducers/foundation/byomValidate';
import { reducer as foundation_byom_register          } from './reducers/foundation/byomRegister';
import { reducer as foundation_byom_download          } from './reducers/foundation/byomDownload';

// Data Signal Marketplace
import { reducer as marketplace_categories } from './reducers/marketplace/categories';
import {
  list      as marketplace_list,
  detail    as marketplace_detail,
  preview   as marketplace_preview,
  subscriptions as marketplace_subscriptions,
  myListings    as marketplace_my_listings,
  earnings      as marketplace_earnings,
  publishedSignals as marketplace_published_signals,
  sellerStatus  as marketplace_seller_status,
  mutations     as marketplace_mutations,
} from './reducers/marketplace/listings';
import { reducer as marketplace_listing_suggestion } from './reducers/marketplace/listingSuggestion';
import { reducer as marketplace_related_by_seller } from './reducers/marketplace/relatedBySeller';
import { reducer as marketplace_related_by_category } from './reducers/marketplace/relatedByCategory';
import { reducer as marketplace_category_counts } from './reducers/marketplace/categoryCounts';
import { reducer as marketplace_icon_upload } from './reducers/marketplace/iconUpload';
import { reducer as billing_rates } from './reducers/billing/rates';
import { reducer as billing_invoices } from './reducers/billing/invoices';

import { reducer as settings_public } from './reducers/settings/public';

// Notifications system: bell drawer + Settings > Notifications tab.
import { reducer as notifications } from './reducers/notifications';

// Relationship Discovery (goals · runs · graph)
import { reducer as discovery_goals } from './reducers/discovery/goals';
import { reducer as discovery_delete_goal } from './reducers/discovery/deleteGoal';
import { reducer as discovery_create_goal } from './reducers/discovery/createGoal';
import { reducer as discovery_price } from './reducers/discovery/price';
import { reducer as discovery_profile_preview } from './reducers/discovery/profilePreview';
import { reducer as discovery_goal_detail } from './reducers/discovery/goalDetail';
import { reducer as discovery_run } from './reducers/discovery/run';
import { reducer as discovery_rerun_goal } from './reducers/discovery/rerunGoal';
import { reducer as discovery_graph } from './reducers/discovery/graph';
import { reducer as discovery_edge } from './reducers/discovery/edge';
import { reducer as discovery_tournament } from './reducers/discovery/tournament';
import { reducer as discovery_start_tournament } from './reducers/discovery/startTournament';
import { reducer as discovery_tournament_control } from './reducers/discovery/tournamentControl';
import { reducer as discovery_select_champion } from './reducers/discovery/selectChampion';
import { reducer as discovery_update_goal } from './reducers/discovery/updateGoal';
import { reducer as discovery_paths } from './reducers/discovery/paths';
import { reducer as discovery_publish_segment } from './reducers/discovery/publishSegment';
import { reducer as discovery_shock_analogues } from './reducers/discovery/shockAnalogues';
import { reducer as discovery_find_similar } from './reducers/discovery/findSimilar';
import { reducer as discovery_studio_forecast } from './reducers/discovery/studioForecast';
import { reducer as discovery_drivers_now } from './reducers/discovery/driversNow';
import { reducer as discovery_scenarios } from './reducers/discovery/scenarios';
import { reducer as discovery_run_scenario } from './reducers/discovery/runScenario';
import { reducer as discovery_run_timing } from './reducers/discovery/runTiming';
import { reducer as discovery_parse_scenario } from './reducers/discovery/parseScenario';
import { reducer as discovery_explain_scenario } from './reducers/discovery/explainScenario';
import { reducer as discovery_delete_scenario } from './reducers/discovery/deleteScenario';
import { reducer as discovery_goal_timeline } from './reducers/discovery/goalTimeline';
import { reducer as discovery_goal_activity } from './reducers/discovery/goalActivity';
import { reducer as discovery_models } from './reducers/discovery/models';
import { reducer as discovery_alerts } from './reducers/discovery/alerts';
import { reducer as discovery_save_alert } from './reducers/discovery/saveAlert';
import { reducer as discovery_delete_alert } from './reducers/discovery/deleteAlert';
import { reducer as discovery_toggle_alert } from './reducers/discovery/toggleAlert';
import { reducer as discovery_preview_alert } from './reducers/discovery/previewAlert';
import { reducer as discovery_alert_org_members } from './reducers/discovery/alertOrgMembers';
import { reducer as discovery_sensitivity } from './reducers/discovery/sensitivity';
import { reducer as discovery_run_sensitivity } from './reducers/discovery/runSensitivity';
import { reducer as discovery_fleet_preview } from './reducers/discovery/fleetPreview';
import { reducer as discovery_fleet_leaderboard } from './reducers/discovery/fleetLeaderboard';
import { reducer as discovery_fleet_member } from './reducers/discovery/fleetMember';
import { reducer as discovery_fleet_runs } from './reducers/discovery/fleetRuns';
import { reducer as discovery_fleet_run_now } from './reducers/discovery/fleetRunNow';
import { reducer as discovery_fleet_bakeoff } from './reducers/discovery/fleetBakeoff';
import { reducer as discovery_fleet_receipts } from './reducers/discovery/fleetReceipts';
import { reducer as discovery_fleet_drivers } from './reducers/discovery/fleetDrivers';
import { reducer as discovery_fleet_scenarios } from './reducers/discovery/fleetScenarios';
import { reducer as discovery_run_fleet_scenario } from './reducers/discovery/runFleetScenario';
import { reducer as blueprint_recommended } from './reducers/blueprints/recommended';
import { reducer as deployment_inference_check } from './reducers/deployments/inferenceCheck';
import { reducer as model_promotion_decision } from './reducers/models/promotionDecision';
import { reducer as model_run_training } from './reducers/models/runTraining';
import { reducer as notifications_page_list } from './reducers/notifications/pageList';
import { reducer as signal_assign_unit } from './reducers/signals/assignUnit';
import { reducer as signal_display_name } from './reducers/signals/displayName';
import { reducer as training_detail } from './reducers/trainings/detail';

// Chat-first setup (workspace creation; data/goal live in the chat)
import { reducer as onboarding_create_workspace } from './reducers/onboarding/createWorkspace';

// Organizations
import { reducer as organization_detail } from './reducers/organizations/detail';
import { reducer as organization_invitation_respond } from './reducers/organizations/invitationRespond';
import { reducer as organization_invitation_revoke } from './reducers/organizations/invitationRevoke';
import { reducer as organization_invitation_verify } from './reducers/organizations/invitationVerify';
import { reducer as organization_invite } from './reducers/organizations/invite';
import { reducer as organization_member_remove } from './reducers/organizations/memberRemove';
import { reducer as organization_member_role } from './reducers/organizations/memberRole';
import { reducer as organization_members } from './reducers/organizations/members';
import { reducer as organization_mine } from './reducers/organizations/mine';
import { reducer as organization_sso_update } from './reducers/organizations/ssoUpdate';
import { reducer as organization_update } from './reducers/organizations/update';
import { reducer as organization_workspace_assign } from './reducers/organizations/workspaceAssign';

// Security (2FA)
import { reducer as security_2fa_disable } from './reducers/security/twoFactorDisable';
import { reducer as security_2fa_enable } from './reducers/security/twoFactorEnable';
import { reducer as security_2fa_recovery_codes } from './reducers/security/twoFactorRecoveryCodes';
import { reducer as security_2fa_setup } from './reducers/security/twoFactorSetup';
import { reducer as security_2fa_status } from './reducers/security/twoFactorStatus';

import { reducer as settings_organization_mine } from './reducers/settings/organizationMine';

// Workspace members panel
import { reducer as workspace_eligible_members } from './reducers/workspaces/eligibleMembers';
import { reducer as workspace_member_add } from './reducers/workspaces/memberAdd';
import { reducer as workspace_member_remove } from './reducers/workspaces/memberRemove';
import { reducer as workspace_members } from './reducers/workspaces/members';

const rootReducer = combineReducers({
  error,
  snackbar,
  datasource_summary,
  datasource_list,
  datasource_schedule,
  datasource_AddUpdateDelete,
  datasource_mock,
  datasource_insights,
  datasource_bulkFetch,
  datasource_connect_inspect,
  datasource_connect_create,
  datasource_connect_import_file,
  datasource_connect_webhook,
  datasource_oauth_start,
  datasource_dataset_inspect,
  datasource_dataset_import,
  datasource_upload_auto,
  datasource_connect_inspect_file,
  datasource_load_sample,
  datasource_create_goal,
  datasource_inspect_source,
  datasource_add_jobs,
  datasource_edit_job_load,
  datasource_update_job,
  datasource_trigger_job,
  datasource_get_source,
  datasource_update_source,
  ingestion_test_rest_call,

  signal_list,
  signal_overview,
  signal_correlation,
  signal_causality,
  signal_relevance,
  signal_delete,
  signal_delete_bulk,
  signal_groups,
  signal_group_assign,
  signal_ask_data,
  signal_latest_analysis,
  signal_analyze,

  user_getUser,
  auth: authReducer,
  
  workspace_list,
  workspace_fetch_llm,
  workspace_create,
  workspace_edit,
  workspace_delete,
  event_record,
  event_streams,
  event_stream_events,
  event_stream_delete,
  workspace_detail,

  segments_list,
  segment_create,
  segment_edit,
  segment_delete,
  segment_detail,
  segment_fields,
  segment_preview,

  blueprints_list,
  blueprints_public_list,
  blueprint_detail,
  blueprint_create,
  blueprint_deploy_foundation,

  models_list,
  model_detail: modelDetailReducer,
  model_create: modelCreateReducer,
  model_edit: modelEditReducer,
  model_delete: modelDeleteReducer,

  trainings_list,
  training_download,
  
  // Add forecasts reducers
  forecasts_list,
  forecast_trigger,
  forecasts_predictions,

  // Inferences (Phase 13.O+ replacement for Forecasts page)
  inferences_list,
  inferences_detail,

  // Add promotion reducers
  model_promote,
  promotion_retry,

  // Add deployment reducers
  deployments_list,
  deployment_delete,
  deployment_detail,
  deployment_usage,
  segment_inference,

  // Add dashboard reducers
  dashboard_summary,

  // Add ingestion reducers
  ingestion_sources,
  ingestion_jobs,
  ingestion_executions,
  ingestion_upload,
  
  // Utilities
  utilities: utilitiesReducer,

  // Billing: credits + Stripe subscription + checkout + portal
  billing_balance,
  billing_transactions,
  billing_estimate,
  billing_snapshot,
  billing_topup,
  billing_subscription,
  billing_checkout,
  billing_portal,
  billing_rates,
  billing_invoices,

  foundation_models_list,
  foundation_model_detail,
  foundation_adapters_list,
  foundation_byom_upload,
  foundation_byom_validate,
  foundation_byom_register,
  foundation_byom_download,

  // Data Signal Marketplace
  marketplace_categories,
  marketplace_list,
  marketplace_detail,
  marketplace_preview,
  marketplace_subscriptions,
  marketplace_my_listings,
  marketplace_earnings,
  marketplace_published_signals,
  marketplace_seller_status,
  marketplace_mutations,
  marketplace_listing_suggestion,
  marketplace_related_by_seller,
  marketplace_related_by_category,
  marketplace_category_counts,
  marketplace_icon_upload,

  settings_public,

  // Notifications (bell + settings)
  notifications,
  notifications_page_list,

  // Relationship Discovery
  discovery_goals,
  discovery_delete_goal,
  discovery_create_goal,
  discovery_price,
  discovery_profile_preview,
  discovery_goal_detail,
  discovery_run,
  discovery_rerun_goal,
  discovery_graph,
  discovery_edge,
  discovery_tournament,
  discovery_start_tournament,
  discovery_tournament_control,
  discovery_select_champion,
  discovery_update_goal,
  discovery_paths,
  discovery_publish_segment,
  discovery_shock_analogues,
  discovery_find_similar,
  discovery_studio_forecast,
  discovery_drivers_now,
  discovery_scenarios,
  discovery_run_scenario,
  discovery_run_timing,
  discovery_parse_scenario,
  discovery_explain_scenario,
  discovery_delete_scenario,
  discovery_goal_timeline,
  discovery_goal_activity,
  discovery_models,
  discovery_alerts,
  discovery_save_alert,
  discovery_delete_alert,
  discovery_toggle_alert,
  discovery_preview_alert,
  discovery_alert_org_members,
  discovery_sensitivity,
  discovery_run_sensitivity,
  discovery_fleet_preview,
  discovery_fleet_leaderboard,
  discovery_fleet_member,
  discovery_fleet_runs,
  discovery_fleet_run_now,
  discovery_fleet_bakeoff,
  discovery_fleet_receipts,
  discovery_fleet_drivers,
  discovery_fleet_scenarios,
  discovery_run_fleet_scenario,

  // View-layer HTTP migration slices
  blueprint_recommended,
  deployment_inference_check,
  model_promotion_decision,
  model_run_training,
  signal_assign_unit,
  signal_display_name,
  training_detail,

  // Chat-first setup
  onboarding_create_workspace,

  // Organizations
  organization_detail,
  organization_invitation_respond,
  organization_invitation_revoke,
  organization_invitation_verify,
  organization_invite,
  organization_member_remove,
  organization_member_role,
  organization_members,
  organization_mine,
  organization_sso_update,
  organization_update,
  organization_workspace_assign,

  // Security (2FA)
  security_2fa_disable,
  security_2fa_enable,
  security_2fa_recovery_codes,
  security_2fa_setup,
  security_2fa_status,

  settings_organization_mine,

  // Workspace members panel
  workspace_eligible_members,
  workspace_member_add,
  workspace_member_remove,
  workspace_members,
});

export default rootReducer;
